
import { RightOutlined } from "@ant-design/icons";
import {

    Row,
    Col,

    Button,

    Form,
    Input,

    Select,

    Radio,

    Space,
    TimePicker


} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';

import ProgrammeService from "../../../api/programme.service";
import timeSlotService from "../../../api/time.slot.service";

import moment from 'moment';


import { EDIT_MODE, SUCCESS_STATUS, TAP_TAG, TIME_FORMAT } from "../../../utility/Constants";

import CustomMessage from "../../common/CustomMessage";
import { addTimeSlot } from "../../../store/timeslotSlice";
import commonUtility from "../../../utility/Utils";
import { TAP_PROGRAM_ID } from "../../../utility/Constants";
import commonService from "../../../api/common.service";
const { Option } = Select;



const TimeSlotEntry = ({ data , onDrawerClose}) => {

    const dispatch = useDispatch();

    // console.log(data)
    const [isFormResponse, setIsFormResponse] = useState(false);
    const [formResponseMessage, setFormResponseMessage] = useState("");
    const [formResponseStatus, setFormResponseStatus] = useState("");


    const [programmeList, setProgrammeList] = useState([]);
    const [programmeGroupList, setProgrammeGroupList] = useState([]);
    const [timeSlotDesc, setTimeSlotDesc] = useState("");

    // const [startTimeSlot, setStartTimeSlot] = useState(moment(data.start_time ,TIME_FORMAT));
    // const [endTimeSlot, setEndTimeSlot] = useState(moment(data.end_time ,TIME_FORMAT));




    const [startTimeSlot, setStartTimeSlot] = useState('');
    const [endTimeSlot, setEndTimeSlot] = useState('');
    const [dayList, setDayList] = useState([]);

    const [isMoringSpecialCoachingRequired, setIsMoringSpecialCoachingRequired] = useState(false);

    const [formDefaultValues, setFormDefaultValues] = useState({
        time_slot_id: data.time_slot_id,
        programme_id: data.programme_id,
        programme_group_id: data.programme_group_id,
        start_time: data.start_time!="" ?  moment(data.start_time, TIME_FORMAT) : '',
        end_time: data.end_time!="" ? moment(data.end_time, TIME_FORMAT) : '',
        time_slot: data.time_slot,
        is_active: data.is_active,
        mode: data.mode,
        morning_or_special_coaching: data.morning_or_special_coaching,
        day_id: data.day_id
    });

    const [mode, setMode] = useState(data.mode);


    const [form] = Form.useForm();

    const onTimeSlotSave = async (values) => {
          console.log(values);
        const data = { formdata: values };

        const response = timeSlotService.save(data).then((resdata) => {

            setIsFormResponse(true);
            setFormResponseStatus(resdata.response_status);
            setFormResponseMessage(resdata.response_msg);

            const x = {
                time_slot_id:commonUtility.randomID(),
                programme_id:values.programme_id,
                programme_group_id:values.programme_group_id,
                
            }
            dispatch(addTimeSlot(x))


        });


    };



    const hideResponseMessage = () => {
        setIsFormResponse(false);
        if(mode=="ADD") {
            form.resetFields();
            form.setFieldsValue({
                time_slot_id: formDefaultValues.time_slot_id,
                mode: formDefaultValues.mode,
                is_active: "Y",
            })
        }

    }



    const onStartTimeChange = (time, timeString) => {
        setTimeSlotDesc("");
        const val = timeString != "" ? timeString : "";
        setStartTimeSlot(val)
    }

    const onEndTimeChange = (time, timeString) => {
        setTimeSlotDesc("");
        const val = timeString != "" ? timeString : "";
        setEndTimeSlot(val)
    };

    const onSelectProgramme = (programid) => {
        if(programid == TAP_PROGRAM_ID){
            setIsMoringSpecialCoachingRequired(true) 
        }
        else{
            setIsMoringSpecialCoachingRequired(false)
            form.setFieldsValue({
                morning_or_special_coaching : "",
                day_id:""
            });
        }
    }




    useEffect(() => {
        startTimeSlot && endTimeSlot ? setTimeSlotDesc(startTimeSlot + " - " + endTimeSlot) : setTimeSlotDesc("")
    }, [startTimeSlot, endTimeSlot]);


    useEffect(() => {
        form.setFieldsValue({ time_slot: timeSlotDesc })

    }, [timeSlotDesc]);

    useEffect(() => {

        mode == EDIT_MODE ?
            form.setFieldsValue({
                time_slot_id: formDefaultValues.time_slot_id,
                programme_id: formDefaultValues.programme_id,
                programme_group_id: formDefaultValues.programme_group_id,
                start_time: moment(formDefaultValues.start_time, 'HH:mm:a'),
                end_time: moment(formDefaultValues.end_time, 'HH:mm:a'),
                time_slot: formDefaultValues.time_slot,
                is_active: formDefaultValues.is_active,
                mode: formDefaultValues.mode,
                morning_or_special_coaching: formDefaultValues.morning_or_special_coaching
            })
            :
            form.setFieldsValue({
                time_slot_id: 0,
                programme_id: '',
                programme_group_id: '',
                start_time: '',
                end_time: '',
                time_slot: '',
                is_active: "Y",
                mode: data.mode,
                morning_or_special_coaching: data.morning_or_special_coaching
            });


        form.setFieldsValue(formDefaultValues)

        onSelectProgramme(form.getFieldValue('programme_id'))

    }, [form]);



    useEffect(() => {
        ProgrammeService.programmeGroupList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeGroupList(res.data.response_data);
            }

        });
    }, []);

    useEffect(() => {
        ProgrammeService.programmeList().then((res) => {
            console.log(res);
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeList(res.data.response_data);
            }

        });
    }, []);

    useEffect(() => {
        commonService.dayList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setDayList(res.data.response_data);
            }
        });
    }, []);



    return (
        <div>
            <div className="form-input-style">

                <Row className="" style={{ background: "transparent" }}>
                    <Col className="" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onTimeSlotSave}
                            autoComplete="off"
                        // initialValues={formDefaultValues}
                        >

                            {/* <Row gutter={20}>
                            <Col className="gutter-row" xs={24} xl={24}>
                                <h5>Note: * fields are required</h5>
                            </Col>
                        </Row> */}
                            <Row gutter={20}>
                                <Col className="gutter-row" xs={24} xl={24}>
                                    <Form.Item name="programme_id" label="Programme" rules={[
                                        {
                                            required: true,
                                            message: 'Programme is required',
                                        },
                                    ]}>
                                        <Select className="text-left" 
                                        onSelect={(e,val)=>onSelectProgramme(e,val)}
                                        
                                        >

                                            <Option value="">Select</Option>

                                            {
                                                programmeList.length > 0 ?
                                                    programmeList.map(programme_data => (
                                                        <Option key={programme_data.programme_id} value={programme_data.programme_id} short_code={programme_data.short_code}>{programme_data.programme_name}</Option>

                                                    ))
                                                    : ''
                                            }
                                        </Select>
                                    </Form.Item>

                                    <Form.Item name="time_slot_id" label="time_slot_id" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="mode" label="mode" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="programme_group_id" label="Group / Shift" rules={[
                                        {
                                            required: true,
                                            message: 'Programme group is required',
                                        },
                                    ]}>
                                        <Select className="text-left" defaultValue="Select">
                                        <Option value="">Select</Option>

                                            {
                                                programmeGroupList.length > 0 ?
                                                    programmeGroupList.map(programme_group => (
                                                        <Option key={programme_group.programme_group_id} value={programme_group.programme_group_id}>{programme_group.programme_group}</Option>

                                                    ))
                                                    : ''
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="morning_or_special_coaching" label="Morning / Special Coaching" rules={[
                                        {
                                            required: isMoringSpecialCoachingRequired,
                                            message: 'Select Morning / Special Coaching',
                                        },
                                    ]}>
                                        <Select className="text-left" defaultValue="Select"
                                        disabled={!isMoringSpecialCoachingRequired}
                                        >
                                            <Option value="">Select</Option>
                                            <Option value="TAPM" valueText="TAP Morning"> Adult Coaching</Option>
                                            <Option value="TAPSC" valueText="Special Coaching"> Special Coaching</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>

                                
                                <Col xs={24} xl={12}>
                                        <Form.Item
                                            label="Day"
                                            name="day_id"
                                            rules={[
                                                {
                                                    required: isMoringSpecialCoachingRequired,
                                                    message: 'Select Day',
                                                },
                                            ]}
                                        >
                                            <Select
                                                className="text-left"
                                                defaultValue=""
                                                disabled={!isMoringSpecialCoachingRequired}
                                            >
                                                {dayList.length > 0
                                                    ? dayList.map((day_list) => (
                                                        <Option
                                                            key={day_list.day_id}
                                                            value={day_list.day_id}
                                                        >
                                                            {day_list.day_code}
                                                        </Option>
                                                    ))
                                                    : ""}
                                            </Select>
                                        </Form.Item>
                                </Col>

                                <Col xs={24} xl={6}>
                                    <Form.Item name="start_time" label="Start Time" rules={[
                                        {
                                            required: true,
                                            message: 'Start time is required',
                                        },
                                    ]}

                                    >
                                        <TimePicker use12Hours format={TIME_FORMAT}  onChange={onStartTimeChange} style={{ width: "100%" }} inputReadOnly={true} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={6}>
                                    <Form.Item name="end_time" label="End Time" rules={[
                                        {
                                            required: true,
                                            message: 'End time is required',
                                        },
                                    ]}>
                                        <TimePicker use12Hours format={TIME_FORMAT} onChange={onEndTimeChange} style={{ width: "100%" }} inputReadOnly={true} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="time_slot" label="Time Slot" >
                                        <Input placeholder="" readOnly={true} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="is_active" label="Active">
                                        <Radio.Group

                                            defaultValue="Y"
                                            style={{ width: "100%" }}
                                            optionType="button"
                                            buttonStyle="solid"
                                        >
                                            <Radio.Button value="Y">Yes</Radio.Button>
                                            <Radio.Button value="N">No</Radio.Button>
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>


                                <Col xs={24} xl={12}>
                                    <Form.Item name="" label=" ">
                                        <Space>

                                            <Button htmlType="submit"  className="custom-button-green" >
                                                Save <RightOutlined />
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Col>


                            </Row>
                        </Form>



                    </Col>
                </Row>
                {
                    // isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} /> : ''
                    isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} onDrawerClose={onDrawerClose} mode={form.getFieldValue('mode')} /> : ''
                }




            </div>
        </div>
    );
};

export default TimeSlotEntry
